/*    
<summary>
  This functional component "ChangePhone1Form" provides form to change the password of the selected user.
</summary>
<returns>Returns JSX</returns>
*/
import { Form, Formik, Field } from "formik";
import { FormattedMessage } from "react-intl";
import { Modal, Button } from "react-bootstrap";
import { formatMessage } from "../../../../translations/format-message";
import Label from "../../../../shared-components/label/label";
import LoaderButton from "../../../../shared-components/button/loader-button";
import { CustomerPhone2Validation } from "../../../../shared-components/FormikFormHandlers/FormikValidationSchema";
import { integerRegex } from "../../../../constants/constants";
import FormikFormInputMobileNumber from "../../../../shared-components/FormikFormHandlers/FormikFormInputMobileNumber";
import { toHalfWidth } from "../../../../helpers/validate-helper";

interface IProps {
  id: number;
  submitHandler: (data: any) => void;
  onModalClosed: () => void;
  loading: boolean;
  initialValues: any;
}

const ChangeCustomerPhone2Form = (props: IProps) => {
  return (
    <>
      <Modal
        className="changePasswordModal correction-modal fancy-modal"
        show={true}
        centered
      >
        <Modal.Header>
          <Modal.Title>
            <button
              title={formatMessage("close")}
              onClick={props.onModalClosed}
              disabled={props.loading}
              className="Crossicons"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="23"
                height="23"
                fill="currentColor"
                className="bi bi-x"
                viewBox="0 0 16 16"
              >
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
              </svg>
            </button>
            <FormattedMessage id="change_phone2" />
          </Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={props.initialValues}
          enableReinitialize
          validationSchema={CustomerPhone2Validation}
          validateOnBlur={false}
          onSubmit={async (values) => {
            const updatedValues = {
              ...values,
              Phone2: toHalfWidth(values.Phone2),
              PostalCode:
                values.PostalCode == "" ? null : String(values.PostalCode),
            };
            props.submitHandler(updatedValues);
          }}
        >
          <Form>
            <Modal.Body>
              <div className="form-group">
                <Label
                  className="label-style"
                  required={false}
                  label="phone2"
                />
              </div>
              <Field
                name="Phone2"
                type="text"
                className="form-control"
                placeholder="enter_mobile_number"
                regex={integerRegex}
                as={FormikFormInputMobileNumber}
              />
            </Modal.Body>
            <div className="modal-footer border-0">
              <Button
                variant="outline-danger me-2"
                disabled={props.loading}
                onClick={props.onModalClosed}
              >
                <i className="bi bi-x-lg me-1"></i>
                <FormattedMessage id="close" />
              </Button>
              <LoaderButton
                type="submit"
                iconName="bi-check-lg"
                isLoading={props.loading}
                text="button_save"
              />
            </div>
          </Form>
        </Formik>
      </Modal>
    </>
  );
};

export default ChangeCustomerPhone2Form;
